import style from './PickupDetailView.css';
import Title from '../../../components/shared/Typography/Title';
import useTranslation from '../../../localization/i18n.context';
import List from '../../../components/shared/List/List';
import ListItem from '../../../components/shared/List/ListItem';
import Alert from '../../../components/shared/Alert/Alert';
import BodyText from '../../../components/shared/Typography/BodyText';
import PinIcon from '../../../components/shared/Icons/PinIcon';
import { UrlEvent } from '../../../sdk/url.event';
import RemoteIcon from '../../../components/shared/RemoteIcon/RemoteIcon';
import { TrackingEvent } from '../../../sdk/tracking.event';
import { PickupDetailProvider, PickupType } from '../PickupProvider';

export default function PickupDetailView({
  title = null,
  locations = [],
  type = PickupType.DEBIT,
}) {
  const { t } = useTranslation();
  const data = PickupDetailProvider(t, title)[type];

  const handleLocationClick = (lat, long, locationName) => {
    TrackingEvent.trigger(
      TrackingEvent.Events.LOCATION_LIST_TAP,
      TrackingEvent.Sources.CAAS,
      {
        option: locationName,
      },
    );
    UrlEvent.open(`https://maps.google.com/maps?daddr=${lat},${long}&amp;ll=`);
  };

  return (
    <main className={style.main}>
      <div className={style.head}>
        <Title text={data.title} />
        <BodyText text={data.text} className={style.subtitle} />
      </div>

      <Alert hasIcon message={data.alert} className={style['info-box']} />
      <List className={style.content} data-testid="store-list">
        {locations.map(el => (
          <ListItem
            title={el.name}
            subtitle={el.address}
            key={el.id}
            infoText={
              el.distance && el.unit ? `${el.distance}${el.unit}` : undefined
            }
            icon={
              el.icon ? (
                <RemoteIcon width={40} height={40} src={el.icon} />
              ) : (
                <PinIcon width={24} height={24} className={style.icon} />
              )
            }
            actionable
            type={ListItem.Type.EXTERNAL}
            size={ListItem.Size.SMALL}
            onClick={() => {
              handleLocationClick(el.lat, el.long, title ?? el.name);
            }}
            data-testid="store"
          />
        ))}
      </List>
    </main>
  );
}
